import React from 'react'
import { createPortal } from 'react-dom'
import { useModal } from './ModalContext'

export default function Modal() {
    const { isOpen, content, closeModal } = useModal()
    if (!isOpen) return null
    return createPortal(
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-body">
                    {content}
                </div>
            </div>
        </div>,
        document.body
    )
}


